import { InitialValuesBuilder, OfferDesignTypes, OfferTypeFormConfig } from 'views/OfferDesign/OfferDesign.types';

import { BundleFormFields } from './components/FormFields/BundleFormFields/BundleFormFields';
import { PopupFormFields } from './components/FormFields/PopupFormFields/PopupFormFields';
import { ProgressBarFormFields } from './components/FormFields/ProgressBarFormFields/ProgressBarFormFields';
import { PromotionFormFields } from './components/FormFields/PromotionFormFields/PromotionFormFields';
import { RollingOfferFormFields } from './components/FormFields/RollingOfferFormFields/RollingOfferFormFields';
import {
  buildBundlePayload,
  buildPopupInitialValues,
  buildPopupPayload,
  buildProgressBarInitialValues,
  buildProgressBarPayload,
  buildPromotionInitialValues,
  buildPromotionPayload,
  buildRollingOfferInitialValues,
  buildRollingOfferPayload,
  bundleSchema,
  popupSchema,
  progressBarSchema,
  promotionSchema,
  rollingOfferSchema
} from './utils';

export const OFFER_TYPE_CONFIG: Partial<Record<OfferDesignTypes, OfferTypeFormConfig>> = {
  [OfferDesignTypes.Bundle]: {
    FormFields: BundleFormFields,
    schema: bundleSchema,
    buildPayload: buildBundlePayload
  },
  [OfferDesignTypes.SpecialOffer]: {
    FormFields: PromotionFormFields,
    schema: promotionSchema,
    buildPayload: buildPromotionPayload
  },
  [OfferDesignTypes.ProgressBar]: {
    FormFields: ProgressBarFormFields,
    schema: progressBarSchema,
    buildPayload: buildProgressBarPayload
  },
  [OfferDesignTypes.RollingOffer]: {
    FormFields: RollingOfferFormFields,
    schema: rollingOfferSchema,
    buildPayload: buildRollingOfferPayload
  },
  [OfferDesignTypes.PopUp]: {
    FormFields: PopupFormFields,
    schema: popupSchema,
    buildPayload: buildPopupPayload
  }
};

export const INITIAL_VALUES_BUILDERS: Record<OfferDesignTypes, InitialValuesBuilder | undefined> = {
  [OfferDesignTypes.SpecialOffer]: buildPromotionInitialValues,
  [OfferDesignTypes.ProgressBar]: buildProgressBarInitialValues,
  [OfferDesignTypes.PopUp]: buildPopupInitialValues,
  [OfferDesignTypes.RollingOffer]: buildRollingOfferInitialValues,
  [OfferDesignTypes.Bundle]: undefined
};
